import {
  DELETE,
  DOWNLOAD,
  DOWNLOAD_TESTS,
  FEATURES,
  RENAME,
  UPLOAD_TESTS,
  COPY,
  VIEW,
  CHANGE_DICTIONARY_STATUS,
  COPY_DICTIONARY,
  DELETE_DICTIONARY,
  DOWNLOAD_DICTIONARY,
  RENAME_DICTIONARY,
  UPLOAD_DICTIONARY,
  DRAFT,
  PUBLISHED,
  GENERATE_VECTOR_EMBEDDINGS,
  REGENERATE_VECTOR_EMBEDDINGS,
  GENERATE_SCENARIO_EMBEDDINGS,
  REGENERATE_SCENARIO_EMBEDDINGS,
  CHANGE_MCP_STATUS,
  ENABLED,
  DISABLED,
} from "src/app/common/constants/app.constants";

export const TEST_CASES = "Test Cases";
export const TEST_SCENARIOS = "Test Scenarios";
export const STEP = "Steps";
export const BOT = "Bots";
export const USER_STORIES = "linkedUserStories"
export const DEV_OBJECTS = "linkedDevObjects"
export const APPLICATION_FIELDS = "applicationFields"
export const DISABLED_CARD_TOOLTIP = 'This Application version creation is under progress.';
export const IMPORT_TESTCASE = 'TESTCASE_IMPORT'
export const INPROGRESS = 'INPROGRESS'
export const FAILED = 'FAILED'
export const IMPORT_INPROGRESS_MESSAGE = 'App version transition is in progress.'
export const DELETE_BOT = 'Delete Bot'
export const DELETE_DICT = 'Delete Dictionary';
export const L3NAME = "l3Name";
export const L3CCID = "l3CcId";
export const L4NAME = "l4Name";
export const L4CCID = "l4CcId";
export const SELENIUM = "SELENIUM"
export const UIPATH = "UIPATH"
export const UI_PATH_TEST_MANAGER_TOOL = "UIPATH TEST MANAGER"
export const COPYAPPVERSION = "CopyAppVersion";
export const ADDTESTCASE = "AddTestCase";

export const AUTO_SYNC_VALUES = {
  NOT_AVAILABLE: 'N/A',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled'
}

export const TAXONOMY_DETAILS_MENU = [
  {
    label: UPLOAD_TESTS,
    value: UPLOAD_TESTS.toLowerCase(),
    accessData: [FEATURES.industryPrint, "UploadTestCase"],
    customClass: 'appVersionMenuItems'
  },
  {
    label: DOWNLOAD_TESTS,
    value: DOWNLOAD_TESTS.toLowerCase(),
    accessData: [FEATURES.industryPrint, "DownloadTestCase"],
    customClass: 'appVersionMenuItems'
  },
  {
    label: COPY,
    value: COPY.toLowerCase(),
    accessData: [FEATURES.industryPrint, "CopyAppVersion"],
    customClass: 'appVersionMenuItems'
  },
  {
    label: RENAME,
    value: RENAME.toLowerCase(),
    accessData: [FEATURES.industryPrint, "UpdateAppVersion"],
    customClass: 'appVersionMenuItems'
  },
  {
    label: DELETE,
    value: DELETE.toLowerCase(),
    accessData: [FEATURES.industryPrint, "DeleteAppVersion"],
    customClass: 'text-danger'
  },
]

export const GENERATE_VECTOR_EMB_BUTTON = {
  label: GENERATE_VECTOR_EMBEDDINGS,
  value: GENERATE_VECTOR_EMBEDDINGS.toLowerCase(),
  accessData: [FEATURES.applicationVersion, 'CopyAppVersion'],
  customClass: 'appVersionMenuItems',
};

export const GENERATE_SCENARIO_EMB_BUTTON = {
  label: GENERATE_SCENARIO_EMBEDDINGS,
  value: GENERATE_SCENARIO_EMBEDDINGS.toLowerCase(),
  accessData: [FEATURES.applicationVersion, 'CopyAppVersion'],
  customClass: 'appVersionMenuItems',
};

export const REGENERATE_VECTOR_EMB_BUTTON = {
  label: REGENERATE_VECTOR_EMBEDDINGS,
  value: REGENERATE_VECTOR_EMBEDDINGS.toLowerCase(),
  accessData: [FEATURES.applicationVersion, 'CopyAppVersion'],
  customClass: 'appVersionMenuItems',
};

export const REGENERATE_SCENARIO_EMB_BUTTON = {
  label: REGENERATE_SCENARIO_EMBEDDINGS,
  value: REGENERATE_SCENARIO_EMBEDDINGS.toLowerCase(),
  accessData: [FEATURES.applicationVersion, 'CopyAppVersion'],
  customClass: 'appVersionMenuItems',
};

export const LIBRARY_CARD_MENU = [
  {
    label: VIEW,
    value: VIEW.toLowerCase()
  },
  {
    label: DOWNLOAD,
    value: DOWNLOAD.toLowerCase(),
    accessData: [FEATURES.library, "DownloadTaxonomy"]
  }
]
export const BOT_DICTIONARY_SUB_MENU = [
  {
    label: DRAFT,
    value: DRAFT
  },
  {
    label: PUBLISHED,
    value: PUBLISHED
  }
];
export const MCP_STATUS_SUB_MENU = [
  {
    label: ENABLED,
    value: ENABLED
  },
  {
    label: DISABLED,
    value: DISABLED
  }
];
export const BOT_DICTIONARY_MENU = [
  {
    label: UPLOAD_DICTIONARY,
    value: UPLOAD_DICTIONARY.toLowerCase(),
    accessData: [FEATURES.botDictionary, "UploadDictionary"]
  },
  {
    label: DOWNLOAD_DICTIONARY,
    value: DOWNLOAD_DICTIONARY.toLowerCase(),
    accessData: [FEATURES.botDictionary, "DownloadDictionary"]
  },
  {
    label: COPY_DICTIONARY,
    value: COPY.toLowerCase(),
    accessData: [FEATURES.botDictionary, "EditDictionary"]
  },
  {
    label: RENAME_DICTIONARY,
    value: RENAME.toLowerCase(),
    accessData: [FEATURES.botDictionary, "EditDictionary"]
  },
  {
    label: CHANGE_DICTIONARY_STATUS,
    value: CHANGE_DICTIONARY_STATUS.toLowerCase(),
    subMenu: BOT_DICTIONARY_SUB_MENU,
    accessData: [FEATURES.botDictionary, "EditDictionary"]
  },
  {
    label: CHANGE_MCP_STATUS,
    value: CHANGE_MCP_STATUS.toLowerCase(),
    subMenu: MCP_STATUS_SUB_MENU,
    accessData: [FEATURES.botDictionary, "EditDictionary"]
  },
  {
    label: DELETE_DICTIONARY,
    value: DELETE.toLowerCase(),
    customClass: 'text-danger',
    accessData: [FEATURES.botDictionary, "EditDictionary"]
  }
];

export const SNACKBAR_MSG = {
  APPLICATION_VERSION_RENAMED: "Application Version renamed successfully",
  APPLICATION_VERSION_DELETED: "Application version has been deleted",
  APPLICATION_VERSION_COPIED: "Application Version copied successfully",
  GOLDEN_DICTIONARY_UPLOADED: "File uploaded successfully",
  GOLDEN_DICTIONARY_DELETED: "Golden Bot Dictionary deleted successfully",
  GOLDEN_DICTIONARY_UPDATED: "Golden Bot Dictionary updated successfully",
  GOLDEN_DICTIONARY_SAVED: "Golden Bot Dictionary saved successfully",
  GOLDEN_DICTIONARY_COPIED: "Golden Bot Dictionary copied successfully",
  GOLDEN_DICTIONARY_TRANSACTION_DELETE: "Bot deleted successfully",
  GOLDEN_DICTIONARY_TRANSACTION_CREATE: "Bot created successfully",
  GOLDEN_DICTIONARY_TRANSACTION_RENAME: "Bot Renamed successfully",
  ERROR_GOLDEN_DICTIONARY_UPLOADED: "Error occurred while uploading file",
  ERROR_GOLDEN_DICTIONARY_DELETED: "Error occurred while deleting Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_UPDATED: "Error occurred while updating Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_SAVED: "Error occurred while saving Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_COPIED: "Error occurred while coping Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_RETRIEVE: "Error occurred while fetching Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_DOWNLOAD: "Error occurred while downloading Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_CREATE: "Error occurred while creating Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_TRANSACTION_CREATE: "Error occurred while creating bot",
  ERROR_GOLDEN_DICTIONARY_TRANSACTION_UPDATE: "Error occurred while updating bot",
  ERROR_GOLDEN_DICTIONARY_TRANSACTION_RETRIEVE: "Error occurred while fetching bot for Golden Bot Dictionary",
  ERROR_GOLDEN_DICTIONARY_TRANSACTION_DELETE: "Error occurred while Deleting bot",
  COPIED_TO_CLIPBOARD: 'Message copied to clipboard',
  PROMPT_SAVED: `Message saved in 'Saved Prompts' `,
  RECOMMENDED_PROMPT_SAVED: `Message saved in 'Recommended Prompts' `,
  ALREADY_EXISTS: 'This prompt has already been saved',
  ALREADY_PRESENT: 'Prompt already present',
  PROMPT_DELETED: 'Prompt deleted successfully',
  ERROR_SAVING_PROMPT: 'Error occurred while saving Prompt',
  ERROR_DELETING_PROMPT: 'Error occurred while deleting Prompt'
}


export const CRITICAL_PATH_LIST = [
  {
    name: 'Core',
    imgUrl: 'assets/images/core.svg',
    description: [
      'Process Model Based Testing',
      'User Stories are mapped to L4',
      'Test Cases are created from L4s, variations are created from User Stories',
      'Scenarios are created from process models linking L4 level test cases',
    ],
    isSelected: false,
  },
  {
    name: 'Alternative',
    imgUrl: 'assets/images/alternative.svg',
    description: [
      'User Story Based Testing',
      'User Stories are mapped to L3',
      'Test Cases are created from User Stories',
      'Scenarios are created from user stories level test cases',
    ],
    isSelected: false,
  },
];

export const CORE= "Core";
export const ALTERNATE= "Alternative";

